import apiClient from "../../../utilities/apiClient";
import LocalStorage, { SESSION_KEY } from "../../../utilities/localStorage";
import { ROLES, ADMIN_ROLES } from "../../../utilities/roles";

const isOfficerRole = (role) =>
  role === ROLES.OFFICER ||
  role === ROLES.PROCUREMENT_BUYER ||
  role === ROLES.REQUESTOR;

export const vendor_reg = (payload) => {
  var user = LocalStorage.getItem(SESSION_KEY);
  const vendor_role = user.roles[0];

  return apiClient.post(
    isOfficerRole(vendor_role)
      ? `${apiClient.Urls.vendor_reg_officer}`
      : `${apiClient.Urls.vendor_reg}`,
    payload,
    true,
    "file"
  );
};

export const goodsService = (payload) => {
  var user = LocalStorage.getItem(SESSION_KEY);
  const vendor_role = user.roles[0];
  return apiClient.get(
    vendor_role === ROLES.USER
      ? `${apiClient.Urls.goodsService}?service=${payload}`
      : `${apiClient.Urls.goodsServiceOfficer}?service=${payload}`,
    "",
    true
  );
};

export const categories = (payload) => {
  var user = LocalStorage.getItem(SESSION_KEY);
  const vendor_role = user.roles[0];
  return apiClient.get(
    vendor_role === ROLES.USER
      ? `${apiClient.Urls.categories}?category=${payload}`
      : `${apiClient.Urls.categoriesOfficer}?category=${payload}`,
    "",
    true
  );
};
export const getItems = (payload) => {
  var user = LocalStorage.getItem(SESSION_KEY);
  const vendor_role = user.roles[0];
  return apiClient.get(
    vendor_role === ROLES.USER
      ? `${apiClient.Urls.getItem}`
      : `${apiClient.Urls.getItemOfficer}`,
    payload,
    true
  );
};

export const itemcategories = (payload) => {
  var user = LocalStorage.getItem(SESSION_KEY);
  const vendor_role = user.roles[0];
  return apiClient.get(
    vendor_role === ROLES.USER
      ? `${apiClient.Urls.subcategories}?subCategory=${payload}`
      : `${apiClient.Urls.subcategoriesOfficer}?subCategory=${payload}`,
    "",
    true
  );
};

export const contact_add = (payload) => {
  return apiClient.post(`${apiClient.Urls.contactSave}`, payload, true);
};

export const add_business_loc = (payload) => {
  var user = LocalStorage.getItem(SESSION_KEY);
  const vendor_role = user.roles[0];
  return apiClient.post(
    vendor_role === ROLES.USER
      ? `${apiClient.Urls.add_business}`
      : `${apiClient.Urls.add_business_officer}`,
    payload,
    true,
    "file"
  );
};

export const view_vendor_details = (payload) => {
  var user = LocalStorage.getItem(SESSION_KEY);
  const vendor_role = user.roles[0];

  return apiClient.get(
    ADMIN_ROLES.includes(vendor_role)
      ? `${apiClient.Urls.view_admin_details}/${payload}`
      : vendor_role === ROLES.USER
      ? `${apiClient.Urls.view_details}/${payload}`
      : `${apiClient.Urls.view_officer_details}/${payload}`,
    "",
    true
  );
};

export const vendor_reg_update = (payload) => {
  return apiClient.patch(
    `${apiClient.Urls.vendor_reg_update}/${payload.vendor_id}`,
    payload,
    true,
    "file"
  );
};

export const vendor_reg_update_documents = (payload) => {
  return apiClient.patch(
    `${apiClient.Urls.vendor_reg_update_documents}/${payload.vendor_id}`,
    payload,
    true,
    "file"
  );
};

export const approve_vendor = (payload) => {
  const userRole = LocalStorage.getItem(SESSION_KEY).roles[0];
  const features = new Set(LocalStorage.getItem("features") || []);
  const isAutoApprove = features.has("auto_approve_vendor");

  return apiClient.patch(
    userRole === ROLES.FINANCE && !isAutoApprove
      ? `${apiClient.Urls.vendor_approve}/${payload.vendor_id}?type=bank`
      : !isAutoApprove
      ? `${apiClient.Urls.vendor_approve}/${payload.vendor_id}`
      : !isOfficerRole(userRole)
      ? `${apiClient.Urls.vendor_approves}/${payload.vendor_id}`
      : `${apiClient.Urls.officer_vendor_approves}/${payload.vendor_id}`,
    payload,
    true
  );
};
export const validatePan = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.validate_pan_officer}`,
    payload,
    true
  );
};

export const createuser = (payload) => {
  return apiClient.post(`${apiClient.Urls.createuser}`, payload, true);
};

export const validate_msme_api = (payload) => {
  return apiClient.post(`${apiClient.Urls.validate_msme}`, payload, true);
};

export const update_business_loc = (payload) => {
  return apiClient.patch(`${apiClient.Urls.update_business}`, payload, true);
};

export const upload_gst_doc = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.upload_gst_doc}`,
    payload,
    true,
    "file"
  );
};

export const banksApi = (payload) => {
  var user = LocalStorage.getItem(SESSION_KEY);

  const id = typeof payload === "object" && payload !== null ? payload.vendor_id : payload;

  return apiClient.get(
    user.roles.some(isOfficerRole)
      ? `${apiClient.Urls.officerBankinformation}/${id}`
      : ADMIN_ROLES.some((role) => user.roles.includes(role))
      ? `${apiClient.Urls.adminBankinformation}/${id}`
      : `${apiClient.Urls.bankinformation}/${user.user_id}`,
    "",
    true
  );
};

export const validate_gst = (payload) => {
  var user = LocalStorage.getItem(SESSION_KEY);
  const vendor_role = user.roles[0];
  return apiClient.post(
    vendor_role === ROLES.USER
      ? `${apiClient.Urls.validate_gst}`
      : isOfficerRole(vendor_role)
      ? `${apiClient.Urls.validate_gst_officer}`
      : `${apiClient.Urls.validate_gst}`,
    payload,
    true
  );
};

export const fetchLatestVendorTermsAndCondtionsDoc = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.fetchLatestVendorTermsAndCondtionsDoc}/view/latest`,
    "",
    true
  );
};

// Submit vendor edits to trigger workflow (tenant_id === 3, 5, 2)
export const submit_vendor_edit_api = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.submit_vendor_edit}/${payload.vendor_id}`,
    payload,
    true
  );
};

// Approve / reject edited vendor info  (admin / officer)
export const approved_edited_vendor_info_api = (payload) => {
  return apiClient.patch(
    `${apiClient.Urls.vendor_workflow_data}/${payload.vendor_id}`,
    payload,
    true
  );
};
